// extracted by mini-css-extract-plugin
export var active = "_dd-7";
export var container = "_dd-0";
export var evenWidth = "_dd-4";
export var large = "_dd-5";
export var outlet = "_dd-8";
export var slide = "_dd-2";
export var small = "_dd-6";
export var tab = "_dd-3";
export var tabs = "_dd-1";